export default window.Splide;